export default __webpack_public_path__ + "static/media/complementary--lane-control--g2.c5f7c989.png";